export default {
    getToken(state){
        return state.token;
    },
    getUser(state){
        return state.user;
    },
    getRelated(state){
        return state.related;
    },
    getHistoryUrl(state){
        return state.historyUrl;
    },
    getMenu(state){
        return state.menu;
    },
    getActions(state){
        return state.actions;
    },
    getJwtExpired(state){
        return state.jwtExpired;
    },
    isActionAllowed(state) {
        return (action) => {
            return state.permissions.includes(action); 
        }
    },
    getSearchRRHH(state){
        return state.search
    },
    getSearchDocumentRRHH(state){
        return state.documentSearch
    },
    getEstadoEmpresa(state){
        return state.estadoEmpresa
    },
    getDropzoneImg(state){
        return state.dropzoneImg
    },
    getValidateSection(state){
        return state.validateSection
    },
    getSections(state){
        return state.sections
    },
    getLocale(state){
        return state.country
    },
    getUserList(state){
        return state.userList
    },
    getActivateDate(state){
        return state.activateDate
    },
    getSSOData(state){
        return state.SSOData
    },
    getFactoryQueryParam(state){
        return state.queryParams.params.factory
    },
    getCleanAction(state){
        return state.cleanAction
    },
    getApplicationDomain(state){
        return state.user.aplicacion.dominio
    }
}